import {OrderModel} from "../Models/OrderModel";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../Models/StateModel";
import {StadiumModel} from "../Models/StadiumModel";
import {EventModel} from "../Models/EventModel";
import {setPanier, setTimeCreationPanier} from "../store/actions";

export const useUpdatePanier = (): (panier: OrderModel) => void => {
    const dispatch = useDispatch()
    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)
    const event = useSelector<StateModel, EventModel | undefined>(state => state.event)
    const selectedPdv = useSelector<StateModel, number | undefined>(state => state.selectedPdv)

    return (panier: OrderModel): void => {
        panier.stadium = stadium ? {id: stadium.id} : {}
        panier.event = event ? {id: event.id} : {}
        panier.pdv = selectedPdv ? {id: selectedPdv} : {}
        dispatch(setTimeCreationPanier(new Date().getTime()))
        panier.priceHT = (panier.orderProducts?.map(o => o.totalPriceHT || 0).reduce((prev, curr) => prev + curr, 0) || 0).toString()
        panier.priceTTC = (panier.orderProducts?.map(o => o.totalPriceTTC || 0).reduce((prev, curr) => prev + curr, 0) || 0).toString()
        panier.totalTva = (panier.orderProducts?.map(o => o.totalTva || 0).reduce((prev, curr) => prev + curr, 0) || 0).toString()
        panier.totalPriceHT = (panier.orderProducts?.map(o => o.totalPriceHT || 0).reduce((prev, curr) => prev + curr, 0) || 0).toString()
        panier.totalPriceTTC = (panier.orderProducts?.map(o => o.totalPriceTTC || 0).reduce((prev, curr) => prev + curr, 0) || 0).toString()

        dispatch(setPanier(panier))
    }
}

/*
createdAt?: Date,
    priceHT?: string,
    priceTTC?: string,
    totalTva?: string,
    totalPriceHT?: string,
    totalPriceTTC?: string,
 */
